<div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-5 m-auto text-left">
      <label class="custom-control custom-checkbox chkbox mb-2" for="AlreadyExpired">
        <input type="checkbox" class="custom-control-input mgntp10" id="AlreadyExpired" value="No, already expired"
          name="in_contract" [(ngModel)]="hgContract.value1" (click)="getIncontract($event)" />
        <label class="custom-control-label font20" for="AlreadyExpired">No, already expired</label>
      </label>
      <div class="custom-control custom-checkbox chkbox mb-2">
        <input type="checkbox" class="custom-control-input mgntp10" id="Expires" value="Yes, Expires on"
          name="in_contract" [(ngModel)]="hgContract.value2" (click)="getIncontract($event)" />
        <label class="custom-control-label font20" for="Expires">Yes, expires on {{contractDate}}</label>
        <div style="display: inline;" class="pull-right datepick" id="datepick3">
          <my-date-picker name="mydate" class="date-format" required
            [options]="myDatePickerOptions" id="date" [(ngModel)]="model" (ngModelChange)="getDate();"
            placeholder="MM/DD/YYYY" required></my-date-picker>
        </div>
      </div>
      <div class="container col-sm-8 webview text-center">
        <button *ngIf="showbutton" class="btn next mr-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'combtn': user_bot}" (click)="next();">Next</button></div>
    </div>
    <div class="mt-5" *ngIf="showTip">
        <div class="m-auto col-sm-12 col-md-6 col-xl-6 blockbg boxclr text-center">
          <img src="assets/images/flash.png" class="mb-1" />
          <p class="text-center tiphead">PRO TIP</p>
          <p class="text-center tipmes">{{questionObj.tip}}</p>
        </div>
      </div>
  </div>
</div>
<div class="container mobileview px-0 mb-4" [attr.id]="questionObj._id" style="float:left;">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="col-sm-12 m-auto">
    <div class="col-12 px-0">
      <label class="custom-control custom-checkbox chkbox mb-2" for="AlreadyExpired_mob">
        <input type="checkbox" value="No, already expired" name="in_contract" class="custom-control-input"
          id="AlreadyExpired_mob" [(ngModel)]="hgContract.value1" (click)="getIncontract($event);" />
        <label class="custom-control-label" for="AlreadyExpired_mob">No, already expired</label>
      </label>
    </div>
    <div class="col-12 px-0">
      <div class="custom-control custom-checkbox chkbox mb-2">
        <input type="checkbox" style="display: inline-block;" class="custom-control-input mgntp10" id="Expires_mob"
          value="Expires on" name="in_contract" [(ngModel)]="hgContract.value2"
          (click)="getIncontract($event)" />
        <label style="display: inline-block;" class="custom-control-label font20" for="Expires_mob">Expires on
          {{contractDate}}
        </label>
        <div style="display: inline-block;" class="pull-right mt-1" id="datepick3">
          <my-date-picker style="display: inline-block; right:0;" name="mydate" class="date-format" required
            [options]="myDatePickerOptions" id="date" [(ngModel)]="model" (ngModelChange)="getDate();"
            placeholder="MM/DD/YYYY" required></my-date-picker>
        </div>
      </div>
    </div>
    <div class="col-12 px-0" style="width:100% !important; text-align: right;">
      <div *ngIf="user_bot" class="mb-3 ash_box text-right">
        <h1 class="ansMob text-right">{{ans_in_contract}}</h1>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="blockbg boxclr p-2">
      <img src="assets/images/flash.png" class="mb-1" style="margin-left:48%" />
      <p class="text-center tiphead">PRO TIP</p>
      <p class="text-center tipmes">{{questionObj.tip}}</p>
    </div>
  </div>
  <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
        <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
        <div class="arrow_box">
            <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
        </div>
    </div>
  </div>
</div>